var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333e49;opacity:0.7;}.cls-2,.cls-4{fill:#fff;}.cls-2,.cls-3{stroke:#fff;stroke-miterlimit:10;stroke-width:24.24px;}.cls-3{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CONTACT"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M500,44.38c-251.64,0-455.6,204-455.6,455.6s204,455.64,455.6,455.64S955.6,751.63,955.6,500,751.61,44.38,500,44.38Zm3,619.12A163.12,163.12,0,0,1,381.12,609a163.48,163.48,0,0,1,243.82,0A163.17,163.17,0,0,1,503,663.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M621.91,609a163.54,163.54,0,0,1-243.82,0,163.46,163.46,0,0,1,243.82,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M663.51,500a162.84,162.84,0,0,1-41.6,109,163.46,163.46,0,0,0-243.82,0A163.51,163.51,0,1,1,663.51,500Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 499.99,
    cy: 459.42,
    rx: 59.46,
    ry: 66.36
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.1729ebee7293e032a0948195a65ae9be.svg";
export { ForwardRef as ReactComponent };